import React, { Component } from "react";
import { withAuth } from "../AuthContext";
import Notification from "../Utils/Notification";
import { INFO } from "../../utils/constants";
import Error from "../Utils/Error";
import { getParameterByName } from "../../utils/utils";
import { withRouter } from "react-router-dom";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            token: "",
            password: "",
            password_confirmation: "",
            error: {},
        };

        this.handleResetPassword = this.handleResetPassword.bind(this);
    }

    componentDidMount() {
        const token = this.props.match.params.token;
        const email = getParameterByName("email");
        this.setState({ token, email });
    }

    handleResetPassword(e) {
        e.preventDefault();
        axios
            .post("/api/password/reset", this.state)
            .then(() => {
                Notification({
                    type: INFO,
                    message: "Your password has been changed successfully",
                });
                //this.props.history.push('/login');
                window.open("/auth0/login", "_self");
            })
            .catch((err) => {
                this.setState({ error: err });
            });
    }

    render() {
        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="text-black font-all-round font-size-34 font-weight-600 mb-2">
                                    Reset password
                                </h3>
                                <div id="login">
                                    <form
                                        method="post"
                                        onSubmit={this.handleResetPassword}
                                    >
                                        <div className="row">
                                            <div className="col-12 form-group">
                                                <label className="text-black font-open-sans font-size-16 font-weight-400">
                                                    New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="password"
                                                    id="password"
                                                    required
                                                    value={this.state.password}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            password:
                                                                e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-12 form-group">
                                                <label className="text-black font-open-sans font-size-16 font-weight-400">
                                                    Confirm New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="password_confirmation"
                                                    id="password_confirmation"
                                                    required
                                                    value={
                                                        this.state
                                                            .password_confirmation
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            password_confirmation:
                                                                e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>
                                            <Error error={this.state.error} />
                                            <div className="submit-btn mt-0">
                                                <button
                                                    className="btn btn-orange btn-block text-white font-open-sans font-weight-700"
                                                    type="submit"
                                                    name="submit"
                                                    id="submit"
                                                >
                                                    Reset password
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(ResetPassword));
